let testName = 'agcy_product_tv_3pack';
if (!document.querySelector('body').classList.contains(testName)) {
	document.querySelector('body').classList.add(testName);
	$( document ).ready(function() {addSelectFragranceFunctionality(); });
}

function addSelectFragranceFunctionality() {
	if (
		!document.querySelector(
			'.acc-fragrance-variants #simple-bundles-options-40718314733638',
		)
	){
		let container = document.querySelector('#simple-bundles-options-container');
          container.insertAdjacentHTML(
				'beforebegin',
				'<div class="acc-fragrance-variants"> </div>'
			);
	document.querySelector('.acc-fragrance-variants').insertAdjacentHTML(
			'afterbegin',
			document.querySelector(
				'#simple-bundles-options-html #simple-bundles-options-40718314733638',
			).outerHTML
		);

	addSelectFragranceModalContent();
	document.querySelector('#simple-bundles-options').remove();
}

}
function addSelectFragranceModalContent() {
	document
		.querySelectorAll(
			'.acc-fragrance-variants #simple-bundles-options-40718314733638 select',
		)
		.forEach((selectEl, index) => {
              selectEl.insertAdjacentHTML(
				'beforebegin',
				renderTravelSelector(index, selectEl),
			);

      /*    
          //travel atomizer
          if (index === 3){ 
              selectEl.insertAdjacentHTML(
				'beforebegin',
				renderTravelSelector(index, selectEl),
			);
        }
            //all other elements
          else {
           			selectEl.insertAdjacentHTML(
				'beforebegin',
				renderCustomSelector(index, selectEl),
			);
		} 
          */

          });
          


	document
		.querySelectorAll('.acc-custom-selector__select--dropdown')
		.forEach(dropdown => {
			dropdown.addEventListener('click', e => {
				document
					.querySelectorAll('.acc-custom-selector__select--dropdown-options')
					.forEach(option => {
						option.classList.remove('show-dropdown');
					});
				dropdown
					.querySelector('.acc-custom-selector__select--dropdown-options')
					.classList.add('show-dropdown');
				dropdown
					.querySelectorAll(
						'.acc-custom-selector__select--dropdown-options-body div',
					)
					.forEach(option => {
						option.classList.remove('selected');
						if (
							option.innerText
								.toLowerCase()
								.includes(
									dropdown
										.querySelector(
											'.acc-custom-selector__select--dropdown-text',
										)
										.innerText.toLowerCase(),
								)
						) {
							option.classList.add('selected');
						}
					});
			});
		});

	document.addEventListener('click', e => {
		if (!e.target.closest('.acc-custom-selector__select--dropdown')) {
			document
				.querySelectorAll('.acc-custom-selector__select--dropdown-options')
				.forEach(option => {
					option.classList.remove('show-dropdown');
				});
		}

		if (e.target.closest('.acc-custom-selector__select--dropdown-options')) {
			document
				.querySelectorAll('.acc-custom-selector__select--dropdown-options')
				.forEach(option => {
					option.classList.remove('show-dropdown');
				});
		}
	});

	document
		.querySelectorAll('.acc-custom-selector__select--dropdown-options')
		.forEach((option, optionIndex) => {
			option
				.querySelectorAll(
					'.acc-custom-selector__select--dropdown-options-body div',
				)
				.forEach(optionValue => {
					optionValue.addEventListener('click', e => {
						console.log(e.currentTarget.id);
						document.querySelectorAll(
							'#simple-bundles-options-40718314733638 select',
						)[optionIndex].value = e.currentTarget.id;
						let dropDownElement =
							e.currentTarget.parentElement.parentElement.parentElement;
						dropDownElement.querySelector(
							'.acc-custom-selector__name',
						).textContent = e.currentTarget.id.split(':')[1];
						dropDownElement.querySelector(
							'.acc-custom-selector__inspiration',
						).textContent = e.currentTarget.id
							.toLowerCase()
							.split(':')[0]
							.split('inspired by')[1];

						getPage(
							`https://altfragrances.com/search?type=product&q=${
								e.currentTarget.id.split(':')[1]
							}`,
							'.search-grid',
						).then(res => {
							if (
								res
									.querySelectorAll('.grid-product')[0]
									.querySelector('.grid-product__image-wrap img')
							)
								dropDownElement.parentElement.parentElement.querySelector(
									'.acc-custom-selector__img',
								).innerHTML = res
									.querySelectorAll('.grid-product')[0]
									.querySelector('.grid-product__image-wrap img').outerHTML;
						});
					});
				});
		});
}

function renderCustomSelector(index, selectElement) {
	return `
		<div class="acc-custom-selector">
			<div class="acc-custom-selector__img">
				<img  src="//altfragrances.com/cdn/shop/files/800x800_Bottles_60ml_Executive_160x.png?v=1686836477" alt="product image">
			</div>
			<div class="acc-custom-selector__select">
				<div class="acc-custom-selector__select--label">
					<span>Name</span> <span>Inspired by</span>
				</div>
				
				<div class="acc-custom-selector__select--dropdown">
					<div class="acc-custom-selector__select--dropdown-value">
						<div class="acc-custom-selector__select--dropdown-text">
							<span class="acc-custom-selector__name">${
								selectElement.value.split(':')[1]
							}</span>
							<span class="acc-custom-selector__inspiration">${
								selectElement.value
									.toLowerCase()
									.split(':')[0]
									.split('inspired by')[1]
							}</span>
						</div>
					</div>
					<img src="https://cdn.shopify.com/s/files/1/0042/7160/3782/files/drop-down-icon.png?v=1660749502" alt="drop down icon">
					<div class="acc-custom-selector__select--dropdown-options">
					<div class="acc-custom-selector__select--dropdown-options-header">
							<span>Name</span>
							<span>Inspired By</span>
						</div>
						<div class="acc-custom-selector__select--dropdown-options-body">
						${Array.from(selectElement.querySelectorAll('option'))
							.map(
								option =>
									`<div id="${option.value}">
							<span>${option.value.split(':')[1]}</span>
							<span>${option.value.toLowerCase().split(':')[0].split('inspired by')[1]}</span>
						</div>`,
							)
							.join('')}
						</div>
						
						
					</div>
				</div>
				
			</div>
		</div>
	`;
}

// get element from another page
function getPage(url, from = 'body') {
	return new Promise((resolve, reject) => {
		let XHRt = new XMLHttpRequest();
		XHRt.responseType = 'document';
		XHRt.open('GET', url, true);
		XHRt.onload = () => resolve(XHRt.response.querySelector(from));
		XHRt.onerror = () => reject(XHRt.statusText);
		XHRt.send();
	});
}


//29/9 - function for temp travel atomizer
function renderTravelSelector(index, selectElement) {
	return `
		<div class="acc-custom-selector">
			<div class="acc-custom-selector__img">
				<img  src="//cdn.shopify.com/s/files/1/0042/7160/3782/files/ALT_Atomizer_PDP_02_800x800_e49f2520-6970-48be-9a7b-3b619262a0d6.png?v=1695920595" alt="product image">
			</div>
			<div class="acc-custom-selector__select">
				<div class="acc-custom-selector__select--label">
					<span>Name</span> <span>Inspired by</span>
				</div>
				
				<div class="acc-custom-selector__select--dropdown">
					<div class="acc-custom-selector__select--dropdown-value">
						<div class="acc-custom-selector__select--dropdown-text">
							<span class="acc-custom-selector__name">${
								selectElement.value.split(':')[1]
							}</span>
							<span class="acc-custom-selector__inspiration">${
								selectElement.value
									.toLowerCase()
									.split(':')[0]
									.split('inspired by')[1]
							}</span>
						</div>
					</div>
					<img src="https://cdn.shopify.com/s/files/1/0042/7160/3782/files/drop-down-icon.png?v=1660749502" alt="drop down icon">
					<div class="acc-custom-selector__select--dropdown-options">
					<div class="acc-custom-selector__select--dropdown-options-header">
							<span>Name</span>
							<span>Inspired By</span>
						</div>
						<div class="acc-custom-selector__select--dropdown-options-body">
						${Array.from(selectElement.querySelectorAll('option'))
							.map(
								option =>
									`<div id="${option.value}">
							<span>${option.value.split(':')[1]}</span>
							<span>${option.value.toLowerCase().split(':')[0].split('inspired by')[1]}</span>
						</div>`,
							)
							.join('')}
						</div>
						
						
					</div>
				</div>
				
			</div>
		</div>
	`;
}